<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.dataFiled.new')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/adm/chart">
              <span>{{$t('tlt.chart.list')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/adm/chart/edit">
              <span>{{$t('tlt.chart.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('chart')"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <!-- <button class="btn btn-primary" type="button" v-on:click="validateForm"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>Save</span></button> -->
          <button class="btn btn-primary" type="button" v-on:click="MMFSave('chart')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>

    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.dataField.name')}}:
                </label>
                <select
                  v-validate="'required'"
                  name="name"
                  :class="{'form-control': true, 'is-invalid': errors.has('name') }"
                  v-model="name"
                >
                  <option :key="index" v-for="(model,index) in models">{{model}}</option>
                </select>
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.chart.xAttribute')}}:
                </label>
                <select
                  v-validate="'required'"
                  name="attribute"
                  :class="{'form-control': true, 'is-invalid': errors.has('xAttribute') }"
                  v-model="xAttribute"
                >
                  <option :key="index" v-for="(modelField,index) in modelFields">{{modelField}}</option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.chart.xName')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="xName"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('xName') }"
                  v-model="xName"
                  type="text"
                />
                <span v-show="errors.has('xName')" class="lbl-obg">{{ errors.first('xName') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  {{$t('lbl.chart.description')}}:
                </label>
                <input
                  name="description"
                  :class="{'form-control form-control-sm': true}"
                  v-model="description"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="card" style="margin-top:20px">
        <div class="card-body">
          <div class="row" :key="index" v-for="(item,index) in chartItems">
            <div class="col-md-3">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.chart.yAttribute')}}:
              </label>
              <select
                v-validate="'required'"
                name="attribute"
                :class="{'form-control': true, 'is-invalid': errors.has('yAttribute') }"
                v-model="item.yAttribute"
              >
                <option :key="index" v-for="(modelField,index) in modelFields">{{modelField}}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.chart.yName')}}:
              </label>
               <input
                  v-validate="'required'"
                  name="yName"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('yName') }"
                  v-model="item.yName"
                  type="text"
                />
            </div>

            <div class="col-md-1">
              <label class="control-label">
                <span class="lbl-obg" style="color:white">1</span>
              </label>
              <div>
                <b-button
                  v-if="chartItems.length!=1"
                  class="btn btn-danger"
                  @click="deleteOne(index)"
                >删除</b-button>
                <b-button
                  v-if="(index+1)==chartItems.length"
                  class="btn btn-warning"
                  @click="addNew()"
                >添加</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { mapMultiRowFields } from "vuex-map-fields";
import { fields } from "@/model/adm/Chart";
import allModel from "@/model/index";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "chart/getField",
  mutationType: "chart/updateField"
});

export default {
  name: "chartEdit",
  data() {
    return {
      models: "",
      modelFields: ""
    };
  },

  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapMultiRowFields("chart", ["entity.chartItems"]),
    ...mapState({
      rows: state => state.chart.rows,

      entity: state => state.chart.entity
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave"]),
     addNew() {
            var ob = {
                yAttribute: '',
                yName: ''
            }
            const context = this.$store;
            context.commit("chart/addChartItem",ob);
        },
        deleteOne(index) {
            const context = this.$store;
            context.commit("chart/deleteChartItem",index);
        },
  },
  created() {
    this.models = Object.keys(allModel);
    this.modelFields = allModel[this.name].fields.map(i =>
      i.replace("entity.", "")
    );
  },
  watch: {
    name: {
      handler(val) {
        this.modelFields = allModel[val].fields.map(i =>
          i.replace("entity.", "")
        );
      }
    }
  }
};
</script>
